var exports = {
  "eB": "xa15a2ab7--73e908--mark-container",
  "NA": "xa15a2ab7--73e908--review-rating",
  "nf": "xa15a2ab7--73e908--link",
  "d4": "xa15a2ab7--73e908--star",
  "_2": "xa15a2ab7--73e908--star-has-value",
  "EP": "xa15a2ab7--73e908--star-not-has-value",
};

module.exports = exports;
